import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { fetchRtoQuestions, saveRtoQuestion } from "../rto-info-v2/actions";

const mapStateToProps = ({
    rtoInfo: {
        pageType,
        questions,
        cmsImageGallery
    },
    user: {
        isWebview
    }
}) => ({
    pageType,
    questions,
    cmsImageGallery,
    isWebview
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchRtoQuestionsConnect: fetchRtoQuestions,
    saveRtoQuestionConnect: saveRtoQuestion
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
